import styled from 'styled-components';

export const ItemColumn = styled.td`
  width: 10em;
`;

export default ItemColumn;
